import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const bgHero = { backgroundImage: `linear-gradient(to right, rgba(10, 10, 10, 0.95) 0%, rgba(10, 10, 10, 0.7) 50%, rgba(10, 10, 10, 0.4) 100%), url('/images/IMG_0983&D8Y23.JPEG')` };
  const bgAbout = { backgroundImage: `linear-gradient(to left, rgba(18, 18, 18, 0.95) 0%, rgba(18, 18, 18, 0.8) 50%, rgba(18, 18, 18, 0.6) 100%), url('/images/IMG_0815&D26Y44.JPEG')` };
  const bgPhilosophy = { backgroundImage: `linear-gradient(to right, rgba(10, 10, 10, 0.92) 0%, rgba(10, 10, 10, 0.75) 50%, rgba(10, 10, 10, 0.5) 100%), url('/images/IMG_0870&D40Y49.JPEG')` };
  const bgTechnique = { backgroundImage: `linear-gradient(to left, rgba(18, 18, 18, 0.93) 0%, rgba(18, 18, 18, 0.8) 50%, rgba(18, 18, 18, 0.55) 100%), url('/images/IMG_0875&D30Y41.JPEG')` };
  const bgExhibitions = { backgroundImage: `linear-gradient(to right, rgba(10, 10, 10, 0.92) 0%, rgba(10, 10, 10, 0.78) 50%, rgba(10, 10, 10, 0.55) 100%), url('/images/IMG_0827&D35Y45.JPEG')` };
  const bgContact = { backgroundImage: `linear-gradient(to top, rgba(10, 10, 10, 0.9) 0%, rgba(10, 10, 10, 0.7) 50%, rgba(10, 10, 10, 0.5) 100%), url('/images/IMG_1014&D28Y37.JPEG')` };

  return (
    <div className="home">
      <section className="hero" style={bgHero}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-line">Hüseyin</span>
            <span className="title-line accent">Zeray</span>
          </h1>
          <p className="hero-subtitle">
            Doğanın sessiz bir gözlemcisi, renk ve ışık ustası. 
            Anadolu manzaralarını ve çalışan kadınlarını tuvallerine taşıyan yağlı boya sanatçısı.
          </p>
          <Link to="/arsiv" className="hero-cta">
            Eserleri Keşfet
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>
      </section>

      <section className="about" style={bgAbout}>
        <div className="about-container">
          <div className="about-image">
            <div className="image-frame">
              <img src="/images/artist.jpeg" alt="Hüseyin Zeray" className="artist-photo" />
            </div>
          </div>
          <div className="about-content">
            <span className="section-label">Sanatçı Hakkında</span>
            <h2>Hüseyin Zeray</h2>
            <p>
              1953 Sivas doğumlu olan sanatçı, 1984'te İzmir Dokuz Eylül Üniversitesi 
              Tıp Fakültesi'nden mezun olmuştur. Resme olan ilgisi ilkokul yıllarında başlamış, 
              uzun yıllar araştırma ve denemeler yapmıştır.
            </p>
            <p>
              1981 yılında İzmir'de Turgut Pura anısına yapılan resim yarışmasında başarı ödülü 
              alması sanat hayatında bir dönüm noktası olmuş, bu sanatçıyı daha fazla çalışmaya 
              yöneltmiştir. Malzeme olarak yağlıboya ve kuru pastel kullanan sanatçının resimlerinde 
              ana temayı Anadolu manzaraları ve Anadolu'nun çalışan kadınları oluşturmaktadır.
            </p>
            <div className="about-stats">
              <div className="stat">
                <span className="stat-number">40+</span>
                <span className="stat-label">Yıllık Deneyim</span>
              </div>
              <div className="stat">
                <span className="stat-number">12+</span>
                <span className="stat-label">Kişisel Sergi</span>
              </div>
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-label">Online Sergi</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="art-philosophy" style={bgPhilosophy}>
        <div className="philosophy-container">
          <span className="section-label">Sanat Anlayışı</span>
          <h2>Hüseyin Zeray'ın Resimleri</h2>
          <div className="philosophy-content">
            <div className="philosophy-text">
              <p>
                Hüseyin Zeray resmi, sanatçının gördüklerini, duyumsadıklarını algıya dönüştürerek 
                spontane diyebileceğimiz bir yorumla tuvale aktardığı yapıtlardır.
              </p>
              <p>
                Resimlerinde renk, ışık, titreşim, tuş gibi öğeler kullanılırken, kent dışı konular, 
                kırlar, deniz kenarları, yün ayıklayan ya da tarlada çalışan kadınlar, ağaçlıklı bölgeler 
                gibi konuları tuvallerine taşıyor. Bu bağlamda doğayı konu alarak yaptığı detaycı resimler, 
                uzun vadede değişen manzaranın saptanması açısından da önem kazanıyor.
              </p>
              <p>
                Bir manzara ustası olarak bilinen Zeray, geniş ve rahat fırça sürüşü, doğanın ayrılmaz 
                bir parçası haline getirdiği duyarlı teknik yöntemi ile özgün bir dile sahip.
              </p>
            </div>
            <div className="philosophy-quote">
              <blockquote>
                "Duygulu, şiirsel peyzaj resmine yönelenler arasında görülen ressam, esnek, yumuşak 
                ve uyumlu çizgi ve renk uygulayıcısıdır. Sanatçının peyzaj temasında ürettiği resimlerindeki 
                mekan derinliği ve atmosfer ilişkileri son derece duyarlı yorumlanmıştır."
              </blockquote>
              <cite>— Doç. Dr. Ayşegül İzer, Milliyet Sanat Dergisi, Aralık 2004</cite>
            </div>
          </div>
        </div>
      </section>

      <section className="technique" style={bgTechnique}>
        <div className="technique-container">
          <div className="technique-content">
            <span className="section-label">Teknik & Üslup</span>
            <h2>Renk ve Işık Ustası</h2>
            <p>
              Hüseyin Zeray'ın yapıtlarından olan Manavgat, Side, Polatlı, Antalya Saklıkent gibi 
              resimlerinde doygun bir sanatçı kişiliği ve sağlam bir natüralizm vardır.
            </p>
            <p>
              Resimlerinde sıcak renkler (turuncu, sarıya çalan toprak rengi) yoğunluklu olarak 
              sezilirken, Manavgat, Bolu gibi resimlerinde yalnızca soğuk renklere öncelik tanımıştır. 
              Bu resimlerinde soğuk kış günlerinin — yani sesin olmadığı, rengin olmadığı bir dünya vardır.
            </p>
            <p>
              "Gris colore" kompozisyonları da olan Zeray, sağlam bir kompozisyon anlayışına ve özgün 
              bir tekniğe sahip. Sıcak-soğuk ve zıt renk oluşumları nitelikli, işlek ve zorlamasız 
              bir anlatımla izleyenlerine ulaştırır.
            </p>
          </div>
          <div className="technique-features">
            <div className="feature">
              <div className="feature-icon">🎨</div>
              <h4>Yağlı Boya</h4>
              <p>Ana malzeme</p>
            </div>
            <div className="feature">
              <div className="feature-icon">✏️</div>
              <h4>Kuru Pastel</h4>
              <p>İkincil malzeme</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🏔️</div>
              <h4>Anadolu</h4>
              <p>Ana tema</p>
            </div>
            <div className="feature">
              <div className="feature-icon">👩‍🌾</div>
              <h4>Çalışan Kadınlar</h4>
              <p>Figür çalışmaları</p>
            </div>
          </div>
        </div>
      </section>

      <section className="exhibitions" style={bgExhibitions}>
        <div className="exhibitions-container">
          <span className="section-label">Sergiler</span>
          <h2>Kişisel Sergilerden Seçmeler</h2>
          <div className="exhibitions-grid">
            <div className="exhibition-item">
              <span className="year">2019</span>
              <span className="venue">ART212, İstanbul</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2013</span>
              <span className="venue">Fikret Otyam Sanat Galerisi, Antalya</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2010</span>
              <span className="venue">Türkiz Otel, Kemer-Antalya</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2009</span>
              <span className="venue">TESK Sergi Salonu, Ankara</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2006</span>
              <span className="venue">Jazz Now Sanat Galerisi, Bodrum</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2006</span>
              <span className="venue">Vakıflar Bankası Sanat Galerisi, İstanbul</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2005</span>
              <span className="venue">Çetin Emeç Sanat Galerisi, İzmir</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2004</span>
              <span className="venue">Deniz Müzesi, İstanbul</span>
            </div>
            <div className="exhibition-item">
              <span className="year">2003</span>
              <span className="venue">TESK Sanat Galerisi, Ankara</span>
            </div>
            <div className="exhibition-item">
              <span className="year">1990</span>
              <span className="venue">Arkeoloji Müzesi, Side</span>
            </div>
          </div>
          <div className="exhibitions-note">
            <h3>Karma Sergiler</h3>
            <p>2007 "İçtenlik 2" Abra Sanat Galerisi İstanbul • 2006 Güzel Sanatlar Galerisi Antalya • 
            2005 Belediye Kültür Merkezi Eskişehir • 1981 Turgut Pura Resim Yarışması İzmir (Başarı Ödülü)</p>
          </div>
        </div>
      </section>

      <section className="contact" style={bgContact}>
        <div className="contact-container">
          <span className="section-label">İletişim</span>
          <h2>Bir Eser Hakkında Bilgi Almak İster Misiniz?</h2>
          <p>Eserler hakkında detaylı bilgi ve satın alma için iletişime geçebilirsiniz.</p>
          <a href="mailto:zerayart@hotmail.com" className="contact-btn">
            İletişime Geç
          </a>
          <p className="contact-email">zerayart@hotmail.com</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
